import { render, staticRenderFns } from "./TerminatedPTW.vue?vue&type=template&id=fcc822e2&scoped=true"
import script from "./TerminatedPTW.vue?vue&type=script&lang=js"
export * from "./TerminatedPTW.vue?vue&type=script&lang=js"
import style0 from "./TerminatedPTW.vue?vue&type=style&index=0&id=fcc822e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc822e2",
  null
  
)

export default component.exports